import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTab } from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import {MatRadioModule} from '@angular/material/radio';
// Material Popups & Modals
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSnackBarModule } from '@angular/material/snack-bar';
// Material Data tables
import { MatSortModule } from '@angular/material/sort';

@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatCardModule,
        MatDividerModule,
        // MatProgressBar,
        MatTabsModule,
        MatChipsModule,
        MatIconModule,
        MatBadgeModule,
        MatGridListModule,
        MatMenuModule,
        MatToolbarModule,
        MatButtonToggleModule,
        DragDropModule,
        MatAutocompleteModule,
        MatInputModule,
        MatTooltipModule,
        MatDialogModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSelectModule,
        // BrowserAnimationsModule,
        MatSidenavModule,
        MatListModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSortModule
    
    ],

    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatCardModule,
        MatDividerModule,
        MatRadioModule,
        MatCheckboxModule,
        MatTabsModule,
        MatChipsModule,
        MatIconModule,
        MatBadgeModule,
        MatGridListModule,
        MatMenuModule,
        MatToolbarModule,
        MatButtonToggleModule,
        DragDropModule,
        MatAutocompleteModule,
        MatInputModule,
        MatTooltipModule,
        MatDialogModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSelectModule,
        // BrowserAnimationsModule,
        MatSidenavModule,
        MatListModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatExpansionModule,

        MatAutocompleteModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatInputModule,
        MatSelectModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatSidenavModule,
        MatToolbarModule,
        MatCardModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatListModule,
        MatStepperModule,
        MatTabsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatBadgeModule,
        MatChipsModule,
        MatIconModule,
        MatBottomSheetModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
    ]
})

export class MaterialModule {

}